<template>
    <div class="dp" :style="computedStyle">
      <img v-if="user.dp" :src="user.dp" alt="User DP" class="dp-image" />
      <span v-else class="dp-initials">{{ initials }}</span>
    </div>
  </template>
  
  <script>
  import { computed } from "vue";
  
  export default {
    name: "UserDP",
    props: {
      user: {
        type: Object,
        required: true,
        default: () => ({
          name: "",
          dp: null,
        }),
      },
    },
    setup(props) {
      const initials = computed(() => {
        if (!props.user.name) return "?";
        const nameParts = props.user.name.split(" ");
        const firstInitial = nameParts[0]?.charAt(0).toUpperCase() || "";
        const secondInitial =
          nameParts.length > 1
            ? nameParts[nameParts.length - 1].charAt(0).toUpperCase()
            : "";
        return firstInitial + secondInitial;
      });
  
      const colorMap = {
        A: "#F94144", B: "#F3722C", C: "#F8961E", D: "#F9844A", E: "#F9C74F",
        F: "#90BE6D", G: "#43AA8B", H: "#577590", I: "#277DA1", J: "#577590",
        K: "#4D908E", L: "#43AA8B", M: "#F3722C", N: "#F94144", O: "#F8961E",
        P: "#F9C74F", Q: "#90BE6D", R: "#43AA8B", S: "#577590", T: "#277DA1",
        U: "#F94144", V: "#F3722C", W: "#F9844A", X: "#F8961E", Y: "#90BE6D",
        Z: "#43AA8B", 
      };
  
      const computedStyle = computed(() => {
        if (props.user.dp) {
          return { borderRadius: "50%" };
        }
  
        const firstLetter = initials.value.charAt(0).toUpperCase();
        const bgColor = colorMap[firstLetter] || "#ccc";
        const textColor = "#fff";
  
        return {
          width: "100%",
          height: "100%",
          backgroundColor: bgColor,
          color: textColor,
          fontSize: "15px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          fontWeight: "bold",
        };
      });
  
      return {
        initials,
        computedStyle,
      };
    },
  };
  </script>
  
  <style scoped>
  .dp {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;
  }
  .dp-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .dp-initials {
    text-transform: uppercase;
    user-select: none;
    margin-top: 1px;
  }
  </style>
  